import { getCloudinaryUrl } from "./cloudinary";

const TRUSTED_PROFILE_SOURCES = [
  {
    handle: '@the_adventureaddicts',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/uploads/1762439779018-5a3cphj7wz.JPG',
  },
  {
    handle: '@adventuringeyes',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/DSC03977-LZl4JQ3ExZWOuNvQuT2jsWEqGjEykp.jpg',
  },
  {
    handle: '@coloradomountainhaus',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/uploads/1762461367964-5cn1nubmtdg.JPG',
  },
  {
    handle: '@darlingtravelsblog',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/inbound1488197892309119046-FWgAGAOjIQQIqupVsVNFBMRfIqiVUE.jpg',
  },
  {
    handle: '@thedailytay',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/kt-02-BfYIM3mktOw19pPcurvh8ruCLMGOwf.jpg',
  },
  {
    handle: '@heleneinbetween',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/helene%20and%20michael%20heidelberg%20christmas%2020242%20%2843%20of%2046%29%20copy%202-0joXS8qo8ZuDmHJg0jpVRmsG2oT8mW.jpg',
  },
  {
    handle: '@tc.travels',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/IMG_5178-PdqwVJiX4M2zCWXY7acUkEeu66p5A2.jpeg',
  },
  {
    handle: '@outofboundsretreats',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/Sunshine%2027-ABtawlYVBRexg17c1hFWloHlXPXNd5.jpg',
  },
  {
    handle: '@littlemountainaframe',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/uploads/1762539629720-iycww9k7i.jpg',
  },
  {
    handle: '@the.everwoods',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/uploads/1762442857720-4infy9zwc3a.JPG',
  },
  {
    handle: '@ouroceanviewyarmouth',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/4a22a320-aa05-498f-b4b4-333253de9eb4.jpg',
  },
  {
    handle: '@thecliffs_hockinghills',
    image: 'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/Youtube%20Thumbnail%202-RoAiY65ZqSZrE7fkTAVR5loJET3Ko7.jpeg',
  },
];

export const TRUSTED_PROFILES = TRUSTED_PROFILE_SOURCES.map((profile) => ({
  ...profile,
  image: getCloudinaryUrl(profile.image, {
    width: 192,
    height: 192,
    crop: 'fill',
    quality: 'auto',
    format: 'auto',
  }) || profile.image,
}));
